import { KVMessageDef } from './index'

interface CameraViewMessage {
  cameraViewPosition: string
  cameraViewRotation: string
  cameraViewId: string
  fov?: number
}

interface CameraViewData {
  position: string
  rotation: string
  fov: number
}

type CameraViewResolver = (data: CameraViewData | null) => void

let currentCameraViewResolver: CameraViewResolver | null = null

/**
 * Registers a resolver function to handle the next cameraView message response
 * Only one resolver can be active at a time due to Kestrel's message structure
 */
export function registerCurrentCameraViewRequest(resolver: CameraViewResolver) {
  currentCameraViewResolver = resolver
}

/**
 * Clears the current camera view resolver
 * Should be called to prevent memory leaks when request is cancelled or times out
 */
export function unregisterCurrentCameraViewRequest() {
  currentCameraViewResolver = null
}

/**
 * Creates a message handler for cameraView responses from Kestrel viewer
 * This handler processes current camera view data and resolves waiting promises
 *
 * @returns KVMessageDef configured to handle cameraView messages
 */
export function getCurrentCameraViewResultMessage(): KVMessageDef {
  return {
    type: 'cameraView',
    requiredData: ['cameraViewPosition', 'cameraViewRotation'],

    callback: (json: Record<string, unknown>) => {
      const message = json as unknown as CameraViewMessage
      if (currentCameraViewResolver) {
        currentCameraViewResolver({
          position: message.cameraViewPosition,
          rotation: message.cameraViewRotation,
          fov: message.fov ?? 60, // Standard Unreal Engine default FOV
        })
        currentCameraViewResolver = null
      }
    },
  }
}
